(function() {

  const flashMessageContainer = document.querySelector('.FlashMessageContainer');
  let messages = [];


  window.FlashMessage = {
    show: showFlashMessage,
    hide: hideFlashMessage,
    toggle: toggleFlashMessage,
  }

  function showFlashMessage( message, type = 'error' ) {
    if( !flashMessageContainer ) {
      throw new Error('Can not create a FlashMessage without a .FlashMessageContainer element');
    }

    let id = getIDFromMessageString(message); // check this message does not already exist
    if( !id ) {
      const element = createMessageElement( message, type );
      id = ~~(Math.random() * 1000);
      messages.push({ id, message, element, type });
      flashMessageContainer.appendChild(element);
    }

    return id;
  }

  function hideFlashMessage( messageID ) {
    const messageDetails = _.findWhere(messages, {id: messageID});
    if( messageDetails ) {
      flashMessageContainer.removeChild(messageDetails.element);
      messages = _.without(messages, messageDetails);
    }
  }

  function toggleFlashMessage( message, show = true, type = 'error') {
    if( show ) {
      showFlashMessage( message, type);
    } else {
      const existingID = getIDFromMessageString(message);
      hideFlashMessage( existingID );
    }
  }

  // Helpers
  function createMessageElement( message, type = 'error') {
    const element = document.createElement('div');
    element.className = `FlashMessage FlashMessage--${type}`;
    element.innerHTML = message;
    return element;
  }

  function getIDFromMessageString( message ) {
    const messageDetails = _.findWhere(messages, {message});
    return (messageDetails) ? messageDetails.id : null;
  }


})();
